import ImagesGalleryRowComponent from "components/core/images-gallery/images-gallery-row/images-gallery-row-component";
import { StyledBadgesGridDesktopComponent } from "./badges-grid-desktop-component.scss";

const BadgesGridDesktopComponent = ({ badges, horizontalPadding }) => {
  return (
    <StyledBadgesGridDesktopComponent horizontalPadding={horizontalPadding} className="badges-grid-desktop-component">
      <ImagesGalleryRowComponent assets={badges} />
    </StyledBadgesGridDesktopComponent>
  );
};

export default BadgesGridDesktopComponent;
